<template>
  <div class="workflow-share-accordiou-wrap">
    <div v-b-toggle="collapseId" class="collapsable-button">
      <b-icon icon="caret-right-fill"></b-icon>
      <p>{{ heading }}</p>
    </div>
    <b-collapse :id="collapseId" class="mt-2">
      <div class="user-identity" v-for="p in policies" :key="p.id">
        <p>{{ p.identity == 'public' ? 'öffentlich' : p.email }}</p>
        <CustomDropdown
          :disabled="p.identity == 'public'"
          className="permission-selector"
          v-if="p.access_level != 'owner'"
          ref="userIdentityPermissionSelector"
          :uniqueReferenceId="p.id"
          @onDropdownOpen="onDropdownOpen"
          @onDropdownClose="onDropdownClose"
        >
          <template v-slot:selected-option>
            <span class="line-clamp"
              >{{ getShareParamsAccessLevelName(p.access_level) }}
            </span>
          </template>
          <template v-slot:option-data>
            <b-dropdown-item
              v-for="level in getDropDownAccessLevels"
              :key="level.name"
              @click="changePolicy(p, level.name)"
              :active="p.access_level === level.name"
            >
              {{ level.caption }}
            </b-dropdown-item>
          </template>
        </CustomDropdown>
        <span class="owner-caption" style="padding-left: 12px" v-else
          >Besitzer</span
        >
        <img
          class="remove-policy"
          :src="require('@/assets/img/trash.svg')"
          @click="removePolicy(p)"
          v-if="p.access_level != 'owner' && !isCurrentUser(p.email)"
        />
        <div v-if="p.id === loadingId" class="loadingoverlay">
          <div class="custom-table-progress-icon"></div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import CustomDropdown from '@/components/widgets/CustomDropdown.vue';
export default {
  data() {
    return {
      collapseId: Date.now().toString(),
    };
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    policies: {
      type: Array,
      default: () => [],
    },
    getDropDownAccessLevels: {
      type: Array,
    },
    getShareParamsAccessLevelName: {
      type: Function,
    },
    loadingId: {
      type: String,
      default: null,
    },
    isCurrentUser: {
      type: Function,
    },
  },
  methods: {
    onDropdownOpen() {
      this.$emit('onDropdownOpen');
    },
    onDropdownClose() {
      this.$emit('onDropdownClose');
    },
    removePolicy(policy) {
      this.$emit('removePolicy', policy);
    },
    changePolicy(policy, levelName) {
      this.$emit('changePolicy', policy, levelName);
    },
  },
  components: {
    CustomDropdown,
  },
};
</script>

<style scoped>
.workflow-share-accordiou-wrap .collapsable-button {
  background-color: transparent !important;
  color: #333343 !important;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  outline: none;
}
.workflow-share-accordiou-wrap .collapsable-button p {
  margin-bottom: 0;
  font-weight: 500;
}
.workflow-share-accordiou-wrap .owner-caption {
  color: #333343;
}
.workflow-share-accordiou-wrap .user-identity .owner-caption {
  color: #333343;
  font-size: 14px;
  padding: 0;
  width: auto;
  display: inline-block;
}

.workflow-share-accordiou-wrap .user-identity {
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 9px;
  justify-content: flex-start;
  width: 100%;
  font-size: 16px;
  position: relative;
}

.workflow-share-accordiou-wrap .user-identity > p {
  display: inline-block;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 60%;
  color: #333343;
  overflow-wrap: anywhere;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 300px;
}

.workflow-share-accordiou-wrap .user-identity > i {
  /* margin-left: 8px; */
  cursor: pointer;
  width: 5%;
  color: #333343;
}

.workflow-share-accordiou-wrap .user-identity ::v-deep button {
  /* padding: 0; */
  line-height: 16px;
  justify-content: space-between;
}

.workflow-share-accordiou-wrap .user-identity .line-clamp {
  /* width: 110px; */
  text-align: left;
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.workflow-share-accordiou-wrap
  .user-identity
  ::v-deep
  .permission-selector
  .custom-dropdown-toggle
  img {
  margin-top: 1px;
}
.workflow-share-accordiou-wrap
  .user-identity
  ::v-deep
  .custom-dropdown-menu
  li {
  width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
}

.workflow-share-accordiou-wrap .user-identity ::v-deep .custom-dropdown-toggle {
  padding-inline: 12px;
  border: none;
}
@media (max-width: 525px) {
  .workflow-share-accordiou-wrap .user-identity .line-clamp {
    max-width: 70px;
  }
}

.workflow-share-accordiou-wrap
  .user-identity
  ::v-deep
  .custom-dropdown-toggle
  img {
  opacity: 0;
}
.workflow-share-accordiou-wrap .user-identity .remove-policy {
  opacity: 0;
}
.workflow-share-accordiou-wrap
  .user-identity:hover
  ::v-deep
  .custom-dropdown-toggle
  img {
  opacity: 1;
}
.workflow-share-accordiou-wrap .user-identity:hover .remove-policy {
  opacity: 1;
}
.workflow-share-accordiou-wrap .user-identity ::v-deep .custom-dropdown-menu {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border: none;
}
.workflow-share-accordiou-wrap ::v-deep .custom-dropdown-toggle {
  border: none;
  color: #333343;
}
.workflow-share-accordiou-wrap
  .collapsable-button[aria-expanded='true']
  .b-icon.bi {
  transition: 0.3s ease-in-out;
  transform: rotate(90deg);
}

.workflow-share-accordiou-wrap .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 14;
  text-align: center;
  border-radius: 4px;
}
.workflow-share-accordiou-wrap .loadingoverlay .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  position: absolute;
  left: 50%;
}
.workflow-share-accordiou-wrap .custom-dropdown.permission-selector {
  border-radius: 4px;
  font-size: 13px;
  width: 155px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
}
.workflow-share-accordiou-wrap .remove-policy {
  height: 14px;
  cursor: pointer;
}
</style>
